import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "../getBaseUrl";

const maxRetries = 2;

const dynamicBaseQuery = async (args: any, api: any, extraOptions: any) => {
  const rawBaseQuery = fetchBaseQuery({ baseUrl: getBaseUrl() });
  return rawBaseQuery(args, api, extraOptions);
};

const baseQuery = retry(dynamicBaseQuery, { maxRetries });

export const liftAPI = createApi({
  reducerPath: "liftAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetLifts", "tagGetLiftsLight", "tagPostLift", "tagPutLift", "tagDeleteLift"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET ALL LIFTS */
    getLifts: builder.query({
      query: (body: any) => ({
        url: `/lifts/?page=${body.page}&limit=${body.limit}${body.searchAndFilterString || ""}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetLifts"],
    }),
    //* *********************************************************** */
    //* GET ALL LIFTS LIGHT */
    getLiftsLight: builder.query({
      query: (body: any) => ({
        url: `/lifts/light/${body.orgId}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetLiftsLight"],
    }),
    //* *********************************************************** */
    //* GET LIFTS BY BANK */
    getLiftsByBank: builder.query({
      query: (body: any) => ({
        url: `/lifts/?page=${body.page}&limit=${body.limit}&filter_target=bank_id&filter=${
          body.bankId
        }${body.searchAndFilterString || ""}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetLifts"],
    }),
    //* *********************************************************** */
    //* CREATE LIFT */
    postLift: builder.mutation({
      query: (body: any) => ({
        url: "/lifts/",
        method: "post",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLifts"],
    }),
    //* *********************************************************** */
    //* EDIT LIFT */
    putLift: builder.mutation({
      query: (body: any) => ({
        url: `/lifts/${body.id}`,
        method: "put",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLifts"],
    }),
    //* *********************************************************** */
    //* DELETE LIFT */
    deleteLift: builder.mutation({
      query: (body: any) => ({
        url: `/lifts/${body.id}`,
        method: "delete",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLifts"],
    }),
    //* *********************************************************** */
  }),
});

export const {
  useLazyGetLiftsQuery,
  useGetLiftsQuery,
  useGetLiftsLightQuery,
  useLazyGetLiftsByBankQuery,
  usePostLiftMutation,
  usePutLiftMutation,
  useDeleteLiftMutation,
} = liftAPI;
